module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-slide",
    class: {
      current: _vm.isCurrent
    },
    style: (_vm.slideStyle),
    on: {
      "click": function($event) {
        _vm.goTo()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ec132fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Slide.vue
// module id = 1810
// module chunks = 180